<template>
  <div class="">
    <div class="white elevation-1 pa-2 layout align-center">
      <v-text-field
        v-model="searchValue"
        :loading="loading"
        prepend-icon="mdi-magnify"
        label="Введите номер метки"
        @keydown.enter="search"
      />
      <v-btn
        :loading="loading"
        :disabled="!this.searchValue"
        text
        @click="search"
        class="ml-2"
        >Поиск</v-btn
      >
    </div>
    <div v-if="!searchInfo && hasSearched" class="white elevation-1 pa-2 mt-2">
      <div class="text-center body-1">Ничего не найдено</div>
    </div>
    <div v-if="!!searchInfo" class="white elevation-1 pa-2 mt-2">
      <h4>Информация о метке</h4>
      <div class="pa-2">
        <span>Code: </span><span>{{ searchInfo.code }}</span>
      </div>
      <div class="pa-2">
        <span>W64Hex8: </span><span>{{ searchInfo.w64hex8 }}</span>
      </div>
      <div class="pa-2">
        <span>Статус: </span
        ><span>{{ searchInfo.status ? "Активирован" : "Неактивирован" }}</span>
      </div>
      <div class="pa-2" v-if="$store.getters.userRole !== 'support'">
        <span>Заявка: </span
        ><router-link
          :to="{ name: 'OrderPage', params: { id: searchInfo.orderId } }"
          >Перейти к заявке</router-link
        >
      </div>
    </div>
  </div>
</template>

<script>
import { errorMessage } from "@/utils";
export default {
  name: "OrdersPage",
  data() {
    return {
      searchValue: null,
      loading: false,
      searchInfo: null,
      hasSearched: false
    };
  },
  methods: {
    async search() {
      if (!this.searchValue || !this.searchValue.trim()) {
        return;
      }
      this.loading = true;
      this.hasSearched = false;
      this.searchInfo = null;
      try {
        this.searchInfo = await this.$store.dispatch(
          "getLabelInfo",
          this.searchValue
        );
        this.hasSearched = true;
      } catch (e) {
        const isLabelNotFound =
          e.status === 404 &&
          (e.code === "label_not_found" ||
            (e.error === "not_found" && (!e.code || e.code === "not_found")));
        if (isLabelNotFound) {
          this.hasSearched = true;
        } else {
          this.$store.dispatch("addMessage", {
            text: errorMessage(e),
            type: "error"
          });
        }
      }
      this.loading = false;
    }
  }
};
</script>
